<template>
  <section class="entry-success-view entry-view">
    <div class="entry-view__logo">
      <img class="entry-view__logo__img" :src="redBullLogo" alt="Red Bull Logo">
    </div>
    <h2 class="entry-success-view__title">
      {{headline}}
    </h2>
    <p class="entry-success-view__checkout">
      {{body}}
    </p>
      <div class="entry-view__content-wrapper">
        <div class="entry-success-view__preview">
          <div class="entry-success-view__preview__thumbnail">
            <img :src="thumbnail" class="entry-success-view__preview__thumbnail__image" v-show="useShares">
          </div>
        </div>
        <div class="entry-success-view__share">
          <ShareLink class="entry-success-view__share__share-link"
            :linkUrl="urls"
            :buttonCopy="copy"
          />
          <div class="entry-success-view__share__share-buttons" v-if="useShares">
            <SocialButton
              iconName="facebook"
              submissionShare
              :link="facebookLink"
            />
            <SocialButton
              iconName="twitter"
              submissionShare
              :link="twitterLink"
            />
          </div>
        </div>
        <div class="entry-success-view__controls">
          <router-link :to="{
            name: 'home',
            query: {
              [sectionParam]: 'submissions'
            }
          }"
          class="entry-view__main-cta"
          >{{back}}</router-link>
        </div>
    </div>
  </section>
</template>

<script>
import {
  mapState,
} from 'vuex';
import redBullLogo from './../assets/images/red-bull-logo.png';
import SocialButton from './../components/social-button';
import ShareLink from './../components/share-link';

import {
  CONTENT_ENTRY_SUCCESS_CREDIT_COPY,
  CONTENT_ENTRY_SUCCESS_BACK_CTA,
  CONTENT_ENTRY_SUCCESS_COPY_CTA,
  CONTENT_GENERAL_TWITTER_PREFIL_ENTRY_SUCCESS,
} from '../../design-tokens/build/dictionary';
import {
  submissionStatuses,
  ENTRY_SUCCESS_HEADLINES,
  ENTRY_SUCCESS_BODY_COPY,
  FACEBOOK_SHARE_TEMPLATE,
  TWITTER_SHARE_TEMPLATE,
  ROUTE_QUERY_PARAMS
} from '../core/config';
import { expandTemplate } from '../core/utils';
import tracking from './../core/tracking';

export default {
  name: 'entry-success-view',
  components: {
    SocialButton,
    ShareLink,
  },
  data() {
    return {
      redBullLogo,
      creditCopy: CONTENT_ENTRY_SUCCESS_CREDIT_COPY,
      back: CONTENT_ENTRY_SUCCESS_BACK_CTA,
      copy: CONTENT_ENTRY_SUCCESS_COPY_CTA,
      sectionParam: ROUTE_QUERY_PARAMS.section,
      tempStatus: submissionStatuses.APPROVED
    };
  },
  mounted() {
    tracking.trackEvent('p-rb-1');
  },
  computed: {
    /**
     * If the submission was rejected, they shouldn't be able to share
     */
    useShares() {
      return this.status !== submissionStatuses.REJECTED;
    },

    /**
     * Status headline for this entry
     */
    headline() {
      // return ENTRY_SUCCESS_HEADLINES[this.tempStatus]; uncomment for temp viewing copy
      return ENTRY_SUCCESS_HEADLINES[this.status] || ENTRY_SUCCESS_HEADLINES.APPROVED;
    },

    /**
     * Status copy for this entry
     */
    body() {
      // return ENTRY_SUCCESS_BODY_COPY[this.tempStatus]; uncomment for temp viewing copy
      return ENTRY_SUCCESS_BODY_COPY[this.status] || ENTRY_SUCCESS_BODY_COPY.APPROVED;
    },

    /**
     * Whether to show the status message
     */
    useStatusMessage() {
      return this.statusMessage && this.statusMessage.length;
    },

    /**
     * The share link for FB
     */
    facebookLink() {
      return expandTemplate(FACEBOOK_SHARE_TEMPLATE, {
        shareUrl: this.urls,
      });
    },

    /**
     * The share link for Twitter
     */
    twitterLink() {
      return expandTemplate(TWITTER_SHARE_TEMPLATE, {
        shareUrl: this.urls,
        text: CONTENT_GENERAL_TWITTER_PREFIL_ENTRY_SUCCESS,
      });
    },

    /**
     * The share link for copy / paste
     */
    shareLink() {
      return this.urls;
    },

    ...mapState('submission', [
      'submissionId',
      'thumbnail',
      'status',
      'urls'
    ]),
  },
  methods: {
  },
};
</script>

<style lang="scss">
.entry-success-view {
  &__logo {
      margin: 0 auto $size-margin-red-bull-logo auto;
      max-width: $size-width-red-bull-logo;
      &__img {
        width: 100%;
      }
    }
    &__title {
      font-family: $font-family-upload;
      font-weight: $font-weight-enter-button;
      font-size: $size-font-size-success-title;
      letter-spacing: $size-letterspacing-success-title;
      margin: $size-margin-success-title-top 0 0 0;

      text-align: center;

      padding-top: 0;
      @include global-media(red-bull-header-large) {
        // red bull media queries are mobile first
        padding-top: 1.8rem;
      }
       @include media(medium) {
         width: 75%;
         margin: 0 auto;
       }

      @include media(small) {
        width: 85%;
        margin: 0 auto;
      }
    }
    &__checkout {
      font-family: $font-family-upload;
      letter-spacing: $size-letterspacing-checkout-link;
      font-size: $size-font-size-checkout-link;
      text-align: center;
      margin: 0 auto $size-margin-entry-success-checkout-bottom auto;
      max-width: 370px;
      @include media(medium) {
        padding-top: 20px;
        width: 80%;
        // margin: 0 auto;
      }
      @include media(small) {
        padding-top: 20px;
        width: 80%;
        // margin: 0 auto;
      }
      &--link {
        color: $color-base-black-base;
      }
    }

    &__message {
      @include body-copy-small;
      color: $color-text-entry-success-message-base;
    }

    &__share {
      display: flex;
      &__share-buttons {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 0 0 auto;
      }
      &__share-link {
        flex: 1 1 auto;
      }
    }
    &__preview {
      text-align: center;
      margin-bottom: $size-margin-entry-success-preview-bottom;
      &__thumbnail {
        &__image {
          display: block;
          max-height: $size-height-entry-preview;
          margin: 0 auto;
          border: $size-border-entry-preview solid $color-border-entry-preview;
          border-radius: $size-border-radius-entry-preview;

          max-width: 100%;
          height: auto;
        }
      }
    }
}
</style>
